import Vue from "vue";
import VueMeta from "vue-meta";
import PortalVue from "portal-vue";
import { InertiaApp } from "@inertiajs/inertia-vue";
import VueRouter from "vue-router";

import css from "@/Plugins/css";
import { HookMethods } from "@barba/core";
window.Vue = Vue;

Vue.config.productionTip = false;
Vue.mixin({
    methods: {
        route: window.route
    }
});
Vue.use(InertiaApp);
Vue.use(VueRouter);
Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(css);

let app = document.getElementById("app");

const Home = require("./Pages/Home/Index.vue").default;
const Contribute = require("./Pages/Contribute/Index.vue").default;
const Whoweare = require("./Pages/WhoWeAre/Index.vue").default;
const Donate = require("./Pages/Donate/Index.vue").default;
const Contact = require("./Pages/Contact/Index.vue").default;

export const routes = [
    {
        path: "/",
        name: "home",
        component: Home
    },
    {
        path: "/how-to-contribute",
        name: "contribute",
        component: Contribute
    },
    {
        path: "/who-we-are",
        component: Whoweare
    },
    {
        path: "/donate",
        component: Donate
    },
    {
        path: "/contact-us",
        component: Contact
    }
];

const router = new VueRouter({
    mode: "history",
    routes
});

new Vue({
    metaInfo: {
        titleTemplate: title =>
            title ? `${title} · Tanam Benih` : "Tanam Benih"
    },
    router,
    render: h =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: name =>
                    import(`@/Pages/${name}`).then(module => module.default)
            }
        })
}).$mount(app);
